import storage from 'viralstyle-ui/src/storage';

import config from 'config';

class VWO {
  vsViewSales() {
    if (config.ENVIRONMENT === 'Production' || storage.get('vwo-enabled')) {
      window.VWO.push(['activate', { customUrl: 'https://viralstyle.com/customer-sales-v2' }]);
    }
  }

  vsViewThankYou() {
    if (config.ENVIRONMENT === 'Production' || storage.get('vwo-enabled')) {
      window.VWO.push(['activate', { customUrl: 'https://viralstyle.com/customer-thank-you-v2' }]);
    }
  }

  vsCompleteOrder() {
    if (config.ENVIRONMENT === 'Production' || storage.get('vwo-enabled')) {
      window._vis_opt_queue = window._vis_opt_queue || [];
      window._vis_opt_queue.push(function() { _vis_opt_register_conversion(4, 44); });
    }
  }
};

export default new VWO();